export default __webpack_public_path__ + "static/media/left-board.f34fd418.svg";